// Placeholder geometry-type icons — UX will provide final designs

import { GeometryType } from "@nens/rana/api-v1";

import { VectorIcon } from "../../../../../icons";

function LineTypeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, display: "block" }}
    >
      <path
        d="M2 12 L6 5 L11 10 L14 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PointTypeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, display: "block" }}
    >
      <circle cx="8" cy="8" r="4.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}

export function GroupIcon({ geometryType }: { geometryType: GeometryType | undefined }) {
  const isPoint = geometryType === "Point" || geometryType === "MultiPoint";
  const isLine =
    geometryType === "LineString" ||
    geometryType === "MultiLineString" ||
    geometryType === "GeometryCollection";

  if (isPoint) return <PointTypeIcon />;
  if (isLine) return <LineTypeIcon />;

  // Default to vector icon for polygon and other types
  return <VectorIcon />;
}
